<template>
    <b-col :cols="columns" :sm="sm" :md="md" :lg="lg">
        <TextBox :widget="widget" v-if="widget.type == 'TextBox'"/>
        <Default :widget="widget" v-if="widget.type == 'Default'"/>
        <Standard :widget="widget" v-if="widget.type == 'Standard'"/>
        <StandardFullIcon :widget="widget" v-if="widget.type == 'StandardFullIcon'"/>
    </b-col>
</template>

<script>
import TextBox from './widgets/TextBox'
import Default from './widgets/Default'
import Standard from './widgets/Standard'
import StandardFullIcon from './widgets/StandardFullIcon'

export default {
    components: {
        TextBox,
        Default,
        Standard,
        StandardFullIcon
    },
    props: {
        widget: {
            type: Object
        },
        columns: {
            type: Number,
            default: 6
        },
        sm: {
            type: Number,
            default: 6
        },
        md: {
            type: Number,
            default: 6
        },
        lg: {
            type: Number,
            default: 6
        },
    },
    data: function() {
        return {}
    }
}
</script>